import * as React from 'react';
import { SearchInput } from 'shared-portal-components-v2';

import MemberCandidateRow from '@/components/organism/CreateSix/steps/StepInternalParticipants/MemberCandidateRow';
import SelectedPersonRow from '@/components/organism/CreateSix/shared/SelectedPersonRow';

export interface StepInternalParticipantsSelectedMember {
  id: string;
  name: string;
  email: string;
}

export interface StepInternalParticipantsCandidateMember {
  id: string;
  name: string;
  email: string;
  initials: string;
}

export interface StepInternalParticipantsViewProps {
  selectedMembers: StepInternalParticipantsSelectedMember[];
  candidateMembers: StepInternalParticipantsCandidateMember[];
  searchValue: string;
  onSearchValueChange: (nextValue: string) => void;
  onRemoveMember: (memberId: string) => void;
  onAddMember: (memberId: string) => void;
}

export function StepInternalParticipantsView(props: StepInternalParticipantsViewProps): React.JSX.Element {
  const { selectedMembers, candidateMembers, searchValue, onSearchValueChange, onRemoveMember, onAddMember } = props;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-2">Invite Internal Members</h3>
        <p className="text-muted-foreground text-sm">
          Add internal staff as members who can view and collaborate in this SIX.
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h4 className="text-sm font-medium">
            Selected Members ({selectedMembers.length})
          </h4>
        </div>

        <div className="space-y-2">
          {selectedMembers.map((selectedMember) => (
            <SelectedPersonRow
              key={selectedMember.id}
              name={selectedMember.name}
              email={selectedMember.email}
              onRemove={() => {
                onRemoveMember(selectedMember.id);
              }}
            />
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <h4 className="text-sm font-medium">Add Members</h4>

        <SearchInput
          value={searchValue}
          onChange={(nextSearchValue : string) => {
            onSearchValueChange(nextSearchValue);
          }}
          placeholder="Search by name or email..."
        />

        <div className="space-y-2 max-h-64 overflow-y-auto">
          {candidateMembers.map((candidateMember) => (
            <MemberCandidateRow
              key={candidateMember.id}
              name={candidateMember.name}
              email={candidateMember.email}
              initials={candidateMember.initials}
              onAdd={() => {
                onAddMember(candidateMember.id);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

StepInternalParticipantsView.displayName = 'StepInternalParticipantsView';

export default StepInternalParticipantsView;
